export default "__VITE_ASSET__4d73eedf__"